import Util from "../util";
import anime from "animejs/lib/anime.es.js";

(function () {
	const readMoreButtons = document.getElementsByClassName("js-read-more-btn");

	if (readMoreButtons.length > 0) {
		for (var i = 0; i < readMoreButtons.length; i++) {
			initReadMoreBtn(readMoreButtons[i]);
		}

		function initReadMoreBtn(btn) {
			console.log(btn);

			btn.addEventListener("click", function (event) {
				event.preventDefault();
				var rmButton = event.target;
				var rmContent = rmButton.parentElement.previousElementSibling;

				var status = !Util.hasClass(rmContent, "text-component__read-more-text--active");
				Util.toggleClass(rmContent, "text-component__read-more-text--active", status);

				anime({
					targets: rmContent,
					duration: 500,
					height: [0, (el) => el.scrollHeight],
					easing: "easeInOutCubic",
				});

				rmButton.remove();
			});
		}
	}
})();

function readMeTextBlock() {}

export default readMeTextBlock;
